const ISO_DATE_LABEL = /^(\d{4})-(\d{2})-(\d{2})$/;
const SLASH_DATE_LABEL = /^(\d{1,2})\/(\d{1,2})(?:\/(\d{4}))?$/;

const buildLocalDate = (year: number, month: number, day: number): Date | null => {
  if (!Number.isInteger(year) || !Number.isInteger(month) || !Number.isInteger(day)) return null;
  if (month < 1 || month > 12) return null;
  if (day < 1 || day > 31) return null;
  const date = new Date(year, month - 1, day);
  if (Number.isNaN(date.getTime())) return null;
  if (date.getFullYear() !== year || date.getMonth() !== month - 1 || date.getDate() !== day) {
    return null;
  }
  return date;
};

const parseChartDateLabel = (label: string): Date | null => {
  const trimmed = label.trim();
  if (!trimmed) return null;

  const isoMatch = ISO_DATE_LABEL.exec(trimmed);
  if (isoMatch) {
    const year = Number(isoMatch[1]);
    const month = Number(isoMatch[2]);
    const day = Number(isoMatch[3]);
    return buildLocalDate(year, month, day);
  }

  const slashMatch = SLASH_DATE_LABEL.exec(trimmed);
  if (slashMatch) {
    const first = Number(slashMatch[1]);
    const second = Number(slashMatch[2]);
    const year = slashMatch[3] ? Number(slashMatch[3]) : new Date().getFullYear();
    const asDayMonth = buildLocalDate(year, second, first);
    if (asDayMonth) return asDayMonth;
    const asMonthDay = buildLocalDate(year, first, second);
    if (asMonthDay) return asMonthDay;
    return null;
  }

  const parsed = new Date(trimmed);
  if (Number.isNaN(parsed.getTime())) return null;
  return new Date(parsed.getFullYear(), parsed.getMonth(), parsed.getDate());
};

export const formatChartDateLabel = (label: string): string => {
  const date = parseChartDateLabel(label);
  if (!date) return label;
  return date.toLocaleDateString(undefined, {
    month: '2-digit',
    day: '2-digit',
  });
};

export const formatChartTooltipDateLabel = (label: string): string => {
  const date = parseChartDateLabel(label);
  if (!date) return label;
  return date.toLocaleDateString(undefined, {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  });
};
